module.exports = __webpack_public_path__ + "img/Dox-walking-button-inactive.d4641a25.svg";